import { render, staticRenderFns } from "./order_evaluation.vue?vue&type=template&id=336d6717&scoped=true&"
import script from "./order_evaluation.vue?vue&type=script&lang=js&"
export * from "./order_evaluation.vue?vue&type=script&lang=js&"
import style0 from "./order_evaluation.vue?vue&type=style&index=0&id=336d6717&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d6717",
  null
  
)

export default component.exports